"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.determineOperationType = exports.OperationType = void 0;
var OperationType;
(function (OperationType) {
    OperationType["NON_NULLABLE"] = "nonNullable";
    OperationType["NULLABLE"] = "nullable";
    OperationType["PAGINATED"] = "paginated";
})(OperationType = exports.OperationType || (exports.OperationType = {}));
function determineOperationType(operation) {
    if (operation.firstPageIndex === 0 || operation.firstPageIndex === 1) {
        return OperationType.PAGINATED;
    }
    if (operation.isNullable) {
        return OperationType.NULLABLE;
    }
    return OperationType.NON_NULLABLE;
}
exports.determineOperationType = determineOperationType;
//# sourceMappingURL=OperationType.js.map